{
  "app": {
    "approveFailed": "Übernehmen fehlgeschlagen: {{error}}",
    "archive": "Archivieren",
    "archiveFailed": "Archivieren fehlgeschlagen: {{error}}",
    "archiveThreadFailed": "Archivieren fehlgeschlagen: {{error}}",
    "archiveThreadMessage": "„{{title}}” wird aus der Seitenleiste ausgeblendet. Der Gesprächsverlauf bleibt auf der Festplatte erhalten.",
    "archiveThreadMidTurn": "Ein Thread kann nicht während eines laufenden Zugs archiviert werden — warte, bis er fertig ist",
    "archiveThreadTitle": "Thread archivieren?",
    "bulkApproveAccepted": "✓ {{n}} übernommen · {{parts}}",
    "bulkApproveFailed": "Sammelübernahme: {{failed}} von {{total}} fehlgeschlagen",
    "bulkApproveToCards": "{{n}}→Karten",
    "bulkApproveToOpen": "{{n}}→OPEN",
    "cardArchived": "{{id}} archiviert",
    "cardDeleted": "{{id}} gelöscht",
    "cardDeletedBrokenReferences": "{{id}} gelöscht — defekte Verweise in: {{refs}}",
    "cardDeletedBrokenRefs": "{{id}} gelöscht; defekte Refs: {{refs}}",
    "cardMarkedStatus": "{{id}} als {{status}} markiert",
    "cardSaved": "{{id}} gespeichert",
    "cardStatusCleared": "Status auf {{id}} zurückgesetzt",
    "cardWrittenBrokenRefs": "{{id}} geschrieben mit defekten Refs: {{refs}}",
    "cardsMarkedStale": "{{id}} erneut bestätigt — {{n}} abhängige Karten als veraltet markiert",
    "cardsUndone": "{{n}} Karten rückgängig gemacht",
    "deleteFailed": "Löschen fehlgeschlagen: {{error}}",
    "discard": "Verwerfen",
    "discardChangesMessage": "In der geöffneten Karte gibt es ungespeicherte Änderungen. Wenn du fortfährst, gehen sie verloren.",
    "discardChangesTitle": "Ungespeicherte Änderungen verwerfen?",
    "generateFailed": "Generieren fehlgeschlagen: {{error}}",
    "markStatusFailed": "Status markieren fehlgeschlagen: {{error}}",
    "packBlank": "leer",
    "packChanged": "Pack auf {{pack}} gewechselt",
    "projectCreated": "Projekt „{{name}}” erstellt",
    "projectDeleted": "Projekt gelöscht",
    "projectImported": "„{{name}}” importiert",
    "proposalApproved": "{{id}} → {{kind}} übernommen",
    "proposalRejected": "{{id}} abgelehnt",
    "proposalRejectedMarked": "{{id}} abgelehnt · {{n}} Karten markiert",
    "rejectFailed": "Ablehnen fehlgeschlagen: {{error}}",
    "renameProjectFailed": "Projekt umbenennen fehlgeschlagen: {{error}}",
    "saveFailed": "Speichern fehlgeschlagen: {{error}}",
    "setModelPreferenceFailed": "Modellpräferenz setzen fehlgeschlagen: {{error}}",
    "threadArchived": "Thread archiviert",
    "threadTitleAnswer": "Antwort",
    "threadTitleDiscuss": "Diskussion",
    "undo": "Rückgängig",
    "undoDeleteFailed": "Rückgängig: {{failed}} von {{total}} Löschungen fehlgeschlagen",
    "untitled": "ohne Titel",
    "cardsMarkedStaleFirst": "You just changed decision {{id}} — {{n}} dependent card(s) flagged stale. This is what separates Draftlize from a chat window: your thinking stays consistent."
  },
  "cardBody": {
    "jumpTo": "springe zu {{id}}"
  },
  "cardPeek": {
    "approveTooltip": "Änderungen anwenden und zu {{kind}} hochstufen",
    "approving": "Übernehme…",
    "archive": "archivieren",
    "archiveTooltip": "aus der Ansicht ausblenden · wikilinks bleiben auflösbar",
    "brokenRefs": "defekte Refs:",
    "brokenRefsTooltip": "Diese wikilink-Ziele existieren im Projekt nicht.",
    "byAgent": "VOM AGENT",
    "byYou": "VON DIR",
    "bySuggested": "VORGESCHLAGEN",
    "byRevised": "ÜBERARBEITET",
    "closeHint": "Esc · außerhalb klicken zum Schließen",
    "closePeekAria": "Peek schließen",
    "confirmDelete": "{{id}} dauerhaft löschen?",
    "confirmReject": "{{id}} ablehnen und löschen?",
    "copy": "kopieren",
    "customKindPlaceholder": "eigene Art",
    "deleteReasonPlaceholder": "Grund (optional, wird in der Gelöscht-Ansicht angezeigt)",
    "deleting": "Lösche…",
    "editLabel": "BEARBEITEN",
    "fieldBody": "INHALT",
    "fieldKind": "ART",
    "fieldPack": "PACK",
    "fieldTitle": "TITEL",
    "history": "Verlauf",
    "historyTooltip": "jede Revision dieser Karte sehen",
    "jumpTo": "springe zu {{id}}",
    "kindOther": "andere…",
    "markStatusTooltip": "Implementierungsstatus dieser Karte markieren",
    "implTimelineLabel": "IMPLEMENTIERUNG",
    "implTimeline": {
      "proposed": {
        "label": "GEPLANT",
        "note": "In der Diskussion vereinbart — noch kein Code."
      },
      "building": {
        "label": "IN ARBEIT",
        "note": "Ein Coding-Agent arbeitet gerade daran."
      },
      "built": {
        "label": "UMGESETZT",
        "note": "Ausgeliefert — die Implementierung entspricht dieser Karte."
      },
      "drift_detected": {
        "label": "DRIFT",
        "note": "Diese Karte wurde nach dem Build geändert — die Implementierung ist womöglich veraltet."
      }
    },
    "packPlaceholder": "(keiner)",
    "reject": "Ablehnen",
    "saveAndApprove": "Speichern & Übernehmen → {{kind}}",
    "saveChangesTooltip": "Änderungen speichern",
    "saveGapTooltip": "den gap speichern (wartet weiterhin auf Übernahme)",
    "saving": "Speichere…",
    "seeHistoryOfDeleted": "Verlauf der gelöschten {{id}} ansehen",
    "stale": "· STALE",
    "statusBuilding": "in Arbeit",
    "statusBuilt": "fertig",
    "statusClear": "(zurücksetzen)",
    "statusDriftDetected": "drift_detected",
    "statusProposed": "vorgeschlagen",
    "unarchive": "Archivierung aufheben",
    "unarchiveTooltip": "in die Ansicht zurückholen (Standard Zeit / Status)",
    "unsaved": "· UNGESPEICHERT",
    "uriTooltip": "@<diese URI> in Claude Code einfügen, um sie als Kontext zu pinnen",
    "yesDelete": "Ja, löschen",
    "yesReject": "Ja, ablehnen"
  },
  "graphShare": {
    "title": "SHARE-KARTE",
    "building": "Share-Karte wird erstellt …",
    "savePng": "Bild speichern",
    "copyLink": "Link kopieren",
    "copied": "Kopiert",
    "error": "Karte konnte nicht erstellt werden: {{error}}",
    "sizeHint": "1080×1440",
    "statsCards_one": "{{count}} Karte",
    "statsCards_other": "{{count}} Karten",
    "statsDecisions_one": "{{count}} Entscheidung",
    "statsDecisions_other": "{{count}} Entscheidungen",
    "tagline": "Brüte deine Ideen mit Draftlize aus"
  },
  "cardRow": {
    "brokenRefs": "defekte Refs:",
    "brokenRefsTooltip": "Diese wikilink-Ziele existieren im Projekt nicht.",
    "byAgent": "VOM AGENT",
    "byYou": "VON DIR",
    "bySuggested": "VORGESCHLAGEN",
    "byRevised": "ÜBERARBEITET",
    "implStatus": {
      "building": {
        "label": "IN ARBEIT",
        "tooltip": "Läuft"
      },
      "built": {
        "label": "✓ FERTIG",
        "tooltip": "Implementierung ausgeliefert"
      },
      "drift_detected": {
        "label": "⚠ DRIFT",
        "tooltip": "Spec hat sich nach der Implementierung geändert. Neu bauen oder neu markieren."
      },
      "proposed": {
        "label": "VORGESCHLAGEN",
        "tooltip": "Zum Bau bestätigt"
      }
    },
    "jumpTo": "springe zu {{id}}",
    "less": "— weniger",
    "mcpRecentTooltip": "in den letzten 24 Std. von einem externen MCP-Client gelesen",
    "more": "+ mehr",
    "pinManualTooltip": "manuell vom Benutzer platziert",
    "pinResetTooltip": "du hast das hier platziert · klicken, um auf LLM-Platzierung zurückzusetzen",
    "seeHistoryOfDeleted": "Verlauf der gelöschten {{id}} ansehen",
    "stale": "· STALE",
    "unknownCard": "unbekannte Karte"
  },
  "cards": {
    "addAFrame": "Frame hinzufügen",
    "addCardsFirst": "erst Karten hinzufügen",
    "addFrameMenu": "Frame hinzufügen…",
    "allCards": "ALLE KARTEN",
    "buildingExport": "erstelle Export…",
    "cardCount_one": "{{count}} Karte",
    "cardCount_other": "{{count}} Karten",
    "cardsLandHere": "Karten landen hier.",
    "cardsLandHereBody": "Sobald der Agent Karten schreibt, erscheinen sie in dieser Spalte. Nach etwa 6 Karten hilft dir das System, sie zu einem Frame zu organisieren.",
    "collecting": "SAMMLE…",
    "collectingBody_one": "{{count}} von 6 Karten. Sprich weiter; sobald du 6 hast, kann der Agent eine Struktur vorschlagen.",
    "collectingBody_other": "{{count}} von 6 Karten. Sprich weiter; sobald du 6 hast, kann der Agent eine Struktur vorschlagen.",
    "computingLayout": "berechne Layout…",
    "deleteFrame": "Frame löschen",
    "deleteFrameConfirm": "Frame „{{name}}” löschen? Die Platzierungen für diesen Frame werden entfernt; die Karten selbst bleiben unverändert.",
    "deleted": "GELÖSCHT",
    "deletedCount_one": "{{count}} gelöscht",
    "deletedCount_other": "{{count}} gelöscht",
    "errDelete": "Löschen",
    "errLoadFrame": "Frame laden",
    "errLoadFrames": "Frames laden",
    "errOverride": "Überschreiben",
    "errRename": "Umbenennen",
    "errReset": "Zurücksetzen",
    "exportFailed": "Export fehlgeschlagen",
    "exportHint": ".zip herunterladen — Karten, Löschungen, vollständiger Verlauf, Threads",
    "exporting": "exportiere…",
    "frameMenu": "Frame-Menü",
    "gapCountHint": "MECE-erforderliche Knoten, die noch keine Karten haben",
    "gapCount_one": "{{count}} gap",
    "gapCount_other": "{{count}} gaps",
    "generateDoc": "Generieren · Designdokument",
    "generateDocHint": "ein Designdokument generieren",
    "generating": "Generiere…",
    "hidden": "AUSGEBLENDET",
    "hiddenHint": "aus dieser Ansicht ausgeschlossen — auf einen Knoten ziehen, um sie zurückzubringen, oder 📌 klicken, um das LLM entscheiden zu lassen",
    "lensStatus": "Status",
    "lensStatusSubtitle": "gruppiert nach Art · decision → statement → gap → …",
    "lensTime": "Zeit",
    "lensTimeSubtitle": "neueste zuerst · Standard",
    "llmCategorized": "vom LLM kategorisiert",
    "noCardsYet": "Noch keine Karten. Sobald der Agent eine schreibt, erscheint sie hier.",
    "noLensHint": "keine Linse — flache Liste aller Karten",
    "nothingToExport": "noch nichts zu exportieren",
    "readyBody_one": "Du hast {{count}} Karte. Wähle einen Frame, um sie zu organisieren — der Agent kann basierend auf dem Geschriebenen einen vorschlagen, oder du nimmst eine Vorlage.",
    "readyBody_other": "Du hast {{count}} Karten. Wähle einen Frame, um sie zu organisieren — der Agent kann basierend auf dem Geschriebenen einen vorschlagen, oder du nimmst eine Vorlage.",
    "readyToOrganize": "BEREIT ZUM ORGANISIEREN",
    "rename": "Umbenennen",
    "renameFramePrompt": "Frame umbenennen",
    "seeDeletedHint": "gelöschte Karten ansehen",
    "showArchived": "Archivierte anzeigen",
    "showArchivedHint": "Ausgeblendete Karten (z. B. Test/Müll) — bleiben in der DB, damit wikilinks auflösen, standardmäßig aus der Ansicht ausgeblendet",
    "staleDocsAria_one": "{{count}} veraltetes Dokument",
    "staleDocsAria_other": "{{count}} veraltete Dokumente",
    "staleDocsHint_one": "{{count}} gespeichertes Dokument könnte veraltet sein — zum Prüfen öffnen",
    "staleDocsHint_other": "{{count}} gespeicherte Dokumente könnten veraltet sein — zum Prüfen öffnen",
    "unplaced": "NICHT PLATZIERT",
    "unplacedHint": "keine klare Zuordnung — ziehe sie auf einen Knoten, sobald du dich entschieden hast",
    "viewHidden_one": "Ausgeblendete anzeigen ({{count}})",
    "viewHidden_other": "Ausgeblendete anzeigen ({{count}})",
    "staleDemoPrompt": "Try the killer mechanic: edit this decision and watch dependent cards flag themselves stale.",
    "staleDemoCta": "TRY IT",
    "staleDemoDismiss": "Dismiss"
  },
  "columnResizer": {
    "resizeHandle": "Diskussionspanel anpassen. Pfeiltasten zum Justieren, Shift für größere Schritte, Doppelklick oder Enter zum Zurücksetzen.",
    "showCards": "Karten anzeigen"
  },
  "common": {
    "back": "Zurück",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "loading": "Lädt…",
    "refresh": "Aktualisieren",
    "retry": "Erneut versuchen",
    "save": "Speichern"
  },
  "computed": {
    "badgeTooltip": "Ein Wert auf dieser Karte wurde durch einen python_compute-Sandbox-Lauf verifiziert. Öffne die Karte, um den Code zu sehen.",
    "durationMs": "{{ms}} ms",
    "exitCode": "Exit {{code}}",
    "inputs": "Eingaben:",
    "label": "π berechnet",
    "runNumber": "Lauf #{{id}}",
    "stdout": "STDOUT"
  },
  "confirm": {
    "confirm": "Bestätigen"
  },
  "dcard": {
    "stale": "STALE"
  },
  "deleted": {
    "backToCards": "zurück zu den Karten",
    "byAgent": "VOM AGENT",
    "byFs": "VON FS",
    "byYou": "VON DIR",
    "daysAgo": "vor {{count}} T",
    "emptyState": "noch keine gelöschten Karten",
    "groupAgentEdit": "Agent hat gelöscht",
    "groupFsDelete": "FS-Löschungen",
    "groupOther": "Sonstige",
    "groupRejectedGap": "Abgelehnte gaps",
    "groupResolvedGap": "Erledigte gaps",
    "groupUserDelete": "Du hast gelöscht",
    "heading": "GELÖSCHT",
    "viewFullHistory": "vollständigen Verlauf ansehen",
    "yesterday": "gestern"
  },
  "discussion": {
    "addToCards": "Zu Karten hinzufügen",
    "addToOpen": "Zu OPEN hinzufügen",
    "agentDecidesHint": "Agent entscheidet, wann Karten geschrieben werden",
    "answerNow": "Jetzt beantworten",
    "attachRefTooltip": "einen Projekt-Ref anhängen",
    "attachedChipTooltip": "als Projekt-Ref angehängt · klicke ×, um die automatische Erwähnung zu entfernen",
    "attachedRemoveAria": "{{name}} entfernen",
    "bulkAcceptAll": "Alle übernehmen ({{parts}})",
    "bulkAddAllToCards": "Alle zu Karten hinzufügen ({{count}})",
    "bulkAddAllToOpen": "Alle zu OPEN hinzufügen ({{count}})",
    "bulkApproveAllTooltip": "jeden Vorschlag in diesem Schwung übernehmen",
    "bulkBreakdownAllQuestions": "(alle Fragen)",
    "bulkBreakdownAllSettled": "(alle geklärt)",
    "bulkBreakdownMixed": "({{questions}} Fragen, {{other}} andere)",
    "bulkExpandTooltip": "jeden Vorschlag einzeln anzeigen, damit du nacheinander handeln kannst",
    "bulkPartCards": "{{count}}→Karten",
    "bulkPartOpen": "{{count}}→OPEN",
    "bulkProposalsCount": "{{count}} Vorschläge",
    "bulkProposalsExpanded": "{{count}} Vorschläge · ausgeklappt",
    "bulkRejectAllTooltip": "jeden Vorschlag in diesem Schwung verwerfen",
    "clickToDismiss": "klicken zum Schließen",
    "collapse": "einklappen",
    "composerDropPlaceholder": "ablegen, um als Projekt-Ref anzuhängen",
    "composerPlaceholder": "Denk laut mit dem Agent…",
    "convertItemsMany": "↳ KONVERTIERE {{count}} EINTRÄGE → OPEN",
    "convertItemsOne": "↳ KONVERTIERE {{count}} EINTRAG → OPEN",
    "convertTooltip": "Eine gezielte Decompose-Distill auf diese einzelne Nachricht anwenden und die Einträge in OPEN sichtbar machen.",
    "converting": "KONVERTIERE…",
    "discuss": "Diskutieren",
    "dismiss": "Verwerfen",
    "dismissAll": "Alle verwerfen",
    "distillButton": "DESTILLIEREN ⌘D",
    "distillTooltip": "Das Gespräch durchgehen und Karten vorschlagen, die wir hätten schreiben sollen",
    "distilling": "DESTILLIERE…",
    "emptyBody": "Der Agent unterhält sich frei, stellt tiefgehende Fragen und schreibt Karten, wenn der Moment klar ist. Am Ende kannst du immer destillieren, um Verpasstes festzuhalten.",
    "emptyTitle": "Beginne mit einer vagen Idee.",
    "expand": "ausklappen",
    "headerTitle": "DISKUSSION",
    "jumpToLatestTooltip": "Zur neuesten Nachricht springen",
    "newReplyMany": "↓ {{count}} NEUE ANTWORTEN",
    "newReplyOne": "↓ {{count}} NEUE ANTWORT",
    "openProjectFirst": "öffne zuerst ein Projekt",
    "pinnedApproveQuestionTooltip": "Fragen können nicht übernommen werden — schreibe eine Antwort und archiviere dann",
    "pinnedApproveTooltip": "hochstufen → {{kind}} (die vorgeschlagene Art)",
    "pinnedBadgeAnswering": "✦ BEANTWORTE {{id}}",
    "pinnedBadgeDiscussing": "✦ DISKUTIERE {{id}}",
    "pinnedRejectTooltip": "verwerfen — den gap löschen und Blöcke als verworfen markieren",
    "pinnedResolveTooltip": "Aufhören, das Gespräch auf diesen gap zu lenken (gap bleibt im Verzeichnis)",
    "pinnedWhyPrefix": "warum:",
    "postResolveDismiss": "VERWERFEN",
    "postResolvePrefix": "Erledigt",
    "postResolveSuffix": ". Hat diese Diskussion neue gaps aufgedeckt?",
    "queuedCancelAria": "geplantes Senden abbrechen",
    "queuedChipTooltip": "in Warteschlange — wird gesendet, sobald der aktuelle Zug fertig ist · × zum Abbrechen",
    "queuedImageMany": "({{count}} Bilder)",
    "queuedImageOne": "({{count}} Bild)",
    "queuedPrefix": "↵ in Warteschlange:",
    "resolve": "Erledigen",
    "roleAgent": "✦ AGENT · {{time}}",
    "roleYou": "DU · {{time}}",
    "runAudit": "AUDIT STARTEN",
    "sandboxRunning": "🐍 sandbox läuft",
    "sendButtonQueue": "anstellen",
    "sendButtonQueueTooltip": "anstellen (↵) — wird gesendet, sobald der aktuelle Zug fertig ist",
    "sendButtonSend": "senden",
    "sendButtonSendTooltip": "senden (↵) · ⇧↵ für neue Zeile",
    "sendButtonStop": "stoppen",
    "sendButtonStopAria": "laufenden Zug stoppen",
    "sendButtonStopTooltip": "stoppen — den laufenden Zug abbrechen",
    "thinkingChars": "{{count}} Zeichen",
    "thinkingLabel": "✦ DENKE · {{time}}",
    "thinkingPlaceholder": "✦ denke",
    "tierChipTooltip": "Stufe: {{tier}}{{suffix}} — klicken zum Ändern",
    "tierCustomLabel": "Eigene:",
    "tierDefaultBadge": "STANDARD",
    "tierEffortHeading": "AUFWAND",
    "tierEffortIgnoredTooltip": "Schnellmodus ist an — der Aufwand wird beim Request ignoriert.",
    "tierFastMode": "Schnellmodus",
    "tierFastModeTooltip": "Denken komplett überspringen. Tausche Argumentationsqualität gegen Erste-Byte-Latenz.",
    "tierModelsHeading": "MODELLE",
    "tierResetToDefault": "AUF STANDARD ZURÜCKSETZEN",
    "tierVisionStickyNote": "Dieser Thread enthält Bilder. Der Server leitet automatisch zu einem bildfähigen Modell weiter, damit frühere Züge lesbar bleiben — unabhängig von der Auswahl.",
    "tierVisionStickyTooltip": "Vision-Sticky: Dieser Thread enthält Bilder, daher leitet der Server unabhängig von der Auswahl zu einem bildfähigen Modell. Trotzdem klicken zum Ändern.",
    "toolApproveQuestionTooltip": "zu OPEN QUESTIONS als verfolgte offene Frage hinzufügen",
    "toolApproveTooltip": "als {{kind}} zu Karten hinzufügen",
    "toolApprovedSummary": "✓ übernommen → {{id}} ({{kind}})",
    "toolDiscussQuestionTooltip": "einen Thread öffnen, um diese Frage mit dem Agent zu beantworten",
    "toolDiscussTooltip": "einen Thread öffnen, um diesen Vorschlag vor dem Übernehmen zu verfeinern",
    "toolJumpTooltip": "klicken, um zu {{id}} zu springen",
    "toolRejectTooltip": "verwerfen — den Vorschlag löschen und Blöcke als verworfen markieren",
    "toolToggleTooltip": "klicken, um die volle Eingabe ein-/auszublenden",
    "truncatedLabel": "⚠ ABGESCHNITTEN · max_tokens erreicht — Antwort gekürzt",
    "truncatedTooltip": "Das Modell hat gestoppt, weil es max_tokens erreicht hat. Erhöhe DRAFTLIZE_MAX_TOKENS oder bitte den Agent, fortzufahren.",
    "untitledGap": "(gap ohne Titel)",
    "untitledQuestion": "(Frage ohne Titel)",
    "uploadFailed": "Upload fehlgeschlagen: {{error}}",
    "uploading": "lade {{count}} hoch…",
    "working": "Arbeite…"
  },
  "distill": {
    "blocksPrefix": "blockiert:",
    "cardsSection": "KARTEN · {{selected}} von {{total}}",
    "cardsSectionHint": "kristallisierter Inhalt — landet beim Commit direkt via write_card",
    "commit": "Commit {{count}}",
    "extractedSoFar": "bisher {{count}} Einträge extrahiert",
    "failed": "Destillieren fehlgeschlagen: {{message}}",
    "gapsSection": "GAPS · {{selected}} von {{total}}",
    "gapsSectionHint": "offene Einträge — erscheinen beim Commit via propose_card in OPEN",
    "headerHint": "Karten: direkt schreiben · gaps: in OPEN sichtbar machen",
    "heading": "Thread destillieren",
    "hintAudit": "projektweite gap-Bestandsaufnahme gegen eine Audit-Linse · Output sind überwiegend gaps mit Priorität",
    "hintDecompose": "die strukturierten Artefakte des Agents (Listen / Hierarchien) in atomare Einträge auflösen",
    "hintRescue": "verpasste Kristallisationen aus diesem Thread einfangen · leichter Bias zu gaps",
    "modeAudit": "Audit",
    "modeDecompose": "Decompose",
    "modeRescue": "Rescue",
    "nothingToExtract": "Nichts zu extrahieren.",
    "nothingToExtractHint": "Der Thread hat keinen neuen kristallisierten Inhalt oder offene Einträge hervorgebracht. Entweder ist er noch im Erkundungsmodus, oder der Agent hat schon währenddessen alles erfasst.",
    "reading": "lese…",
    "scanning": "SCANNE DEN THREAD",
    "scanningHint": "Karten + gaps aus dem Gespräch",
    "selectedBreakdown": "({{cards}} Karten · {{gaps}} gaps)",
    "selectedCount": "{{selected}} von {{total}} ausgewählt",
    "whyPrefix": "warum:"
  },
  "documents": {
    "cardCount": "{{count}} Karten",
    "confirmDelete": "„{{title}}” löschen? Das kann nicht rückgängig gemacht werden.",
    "emptyBody": "Wähle links eine Vorlage, um aus deinen Karten ein frisches Dokument zu generieren. Gespeicherte Dokumente erscheinen wieder in dieser Liste; wir markieren sie als STALE, wenn sich Quellkarten ändern, damit du weißt, dass du sie neu generieren solltest.",
    "emptyList": "Noch keine gespeicherten Dokumente. Wähle oben eine Vorlage, um eines zu generieren.",
    "emptyTitle": "Langform lebt hier.",
    "errDelete": "Löschen: {{message}}",
    "heading": "Dokumente",
    "newFromTemplate": "+ NEU AUS VORLAGE",
    "regenerate": "Neu generieren",
    "savedCount": "{{count}} gespeichert",
    "stale": "STALE",
    "staleBanner": "Eine oder mehrere Quellkarten haben sich seit der Generierung geändert.",
    "templatesToggle": "▴ Vorlagen",
    "share": "Share",
    "shareCopied": "Link copied"
  },
  "frame": {
    "acceptAndUse": "Übernehmen und verwenden",
    "designSectionHeading": "ENTWIRF EINEN FRAME AUS DEINEN KARTEN",
    "designingBody": "Lese deine Karten und baue eine Topologie auf, die auf dem fußt, was du tatsächlich geschrieben hast. {{seconds}}s verstrichen.",
    "designingCardCount": "{{count}} KARTEN",
    "designingTopology": "ENTWERFE TOPOLOGIE",
    "errCloneFailed": "Klonen fehlgeschlagen: {{message}}",
    "errLoadTemplates": "Vorlagen laden: {{message}}",
    "errSaveFailed": "Speichern fehlgeschlagen: {{message}}",
    "errSuggestFailed": "Vorschlag fehlgeschlagen: {{message}}",
    "haveAgentDesign": "Agent einen entwerfen lassen",
    "headingAdd": "Frame hinzufügen",
    "headingSuggested": "Vorgeschlagener Frame",
    "meceTag": "[MECE]",
    "nodeCount": "{{count}} Knoten",
    "orPickTemplate": "ODER VORLAGE WÄHLEN",
    "proposedTopology": "VORGESCHLAGENE TOPOLOGIE · {{nodes}} KNOTEN · ABGELEITET AUS {{cards}} KARTEN",
    "recommendedByPack": "★ empfohlen vom {{pack}}-Pack",
    "saving": "SPEICHERE",
    "suggestNeedMore": "Mindestens 6 Karten nötig (du hast {{count}}). Sprich weiter und versuche es erneut.",
    "suggestReady": "Liest deine {{count}} Karten und schlägt eine Topologie vor, die auf dem fußt, was du tatsächlich geschrieben hast. ~10–30s."
  },
  "gaps": {
    "answer": "beantworten",
    "answerTitle": "einen Thread öffnen, um diese Frage gemeinsam mit dem Agent durchzuarbeiten",
    "approveTitleCard": "als {{kind}} hinzufügen (landet in der Kartenspalte)",
    "approveTitleQuestion": "als Frage in OPEN QUESTIONS hinzufügen",
    "approveToCards": "Zu Karten hinzufügen",
    "approveToOpen": "Zu OPEN hinzufügen",
    "archive": "archivieren",
    "archiveTitle": "diese Frage ausblenden — wikilinks bleiben auflösbar",
    "auditButton": "+ AUDIT",
    "auditGapsButton": "+ GAPS PRÜFEN",
    "auditInProgress": "Audit läuft…",
    "auditNeedsThread": "Öffne oder erstelle zuerst einen Thread",
    "auditTitle": "Projektweites gap-Audit starten — fächert konkrete gaps in OPEN auf",
    "auditingBusy": "PRÜFE…",
    "blocksLabel": "blockiert:",
    "citedLabel": "zitiert:",
    "citedTitle": "Hover hebt zitierte Züge hervor; auf eine Zug-ID klicken, um dorthin zu springen",
    "collapse": "einklappen",
    "discuss": "Diskutieren",
    "discussTitle": "diesen gap an die Diskussion anheften und ihn gemeinsam lösen",
    "dismiss": "Verwerfen",
    "dismissTitle": "verwerfen — den Vorschlag löschen und Blöcke als verworfen markieren",
    "emptyState": "Nichts offen. Einträge landen hier, wenn der Agent etwas Unbekanntes markiert, eine Karte vorschlägt oder du ein Audit startest.",
    "expand": "ausklappen",
    "frameLabel": "frame",
    "heading": "OPEN",
    "hidePanel": "OPEN-Panel ausblenden",
    "jumpTo": "springe zu {{id}}",
    "jumpToTurn": "springe zu {{turn}} in der Diskussion",
    "nodeEmpty": "{{label}} ist leer",
    "openCard": "diese Karte öffnen",
    "openProbeCount": "{{count}} Probe-Fragen öffnen",
    "openProbePopover": "Probe-Popover öffnen",
    "priorityNone": "UNSORTIERT",
    "priorityP0": "P0 — BLOCKER",
    "priorityP1": "P1 — SUBSYSTEM",
    "priorityP2": "P2 — FEINSCHLIFF",
    "priorityP3": "P3 — INFRA / OPS",
    "questionLabel": "question",
    "railExpand": "OPEN-Panel ausklappen",
    "railExpandCount": "{{count}} offene Einträge — klicken zum Ausklappen",
    "refsLabel": "Refs:",
    "sectionFrameGaps": "FRAME GAPS",
    "sectionOpenQuestions": "OPEN QUESTIONS",
    "sectionPendingReview": "PENDING REVIEW",
    "sectionStaleRipple": "STALE RIPPLE",
    "untitled": "(ohne Titel)",
    "untitledProposal": "(Vorschlag ohne Titel)",
    "untitledQuestion": "(Frage ohne Titel)",
    "whyPrefix": "warum:"
  },
  "generate": {
    "copied": "Kopiert ✓",
    "copyMarkdown": "Markdown kopieren",
    "copyTitle": "Markdown in die Zwischenablage kopieren",
    "downloadMd": ".md herunterladen",
    "downloadTitle": "als .md herunterladen",
    "fromCards": "aus {{count}} Karten",
    "heading": "Generiert · {{template}}",
    "saveFailed": "Speichern fehlgeschlagen: {{message}}",
    "saveTitle": "Dokument im Projekt speichern",
    "saved": "Gespeichert ✓",
    "savedTitle": "Dokument gespeichert",
    "saving": "Speichere…",
    "streaming": "streame…",
    "titlePlaceholder": "Dokumenttitel…",
    "viewRaw": "Roh",
    "viewRendered": "Gerendert",
    "waitStreaming": "warte, bis das Streaming fertig ist"
  },
  "history": {
    "byAgent": "VOM AGENT",
    "byFs": "VON FS",
    "byYou": "VON DIR",
    "closeAria": "Verlauf schließen",
    "current": "AKTUELL",
    "daysAgo": "vor {{count}} T",
    "diffNoPrior": "Diff (keine vorherige Rev)",
    "diffVsRev": "Diff vs. Rev {{rev}}",
    "fieldBody": "Inhalt",
    "fieldKind": "Art",
    "fieldPack": "Pack",
    "fieldTitle": "Titel",
    "filterFs": "fs",
    "filterFsTooltip": "Dateisystem-Edits anzeigen (vim, Obsidian, git pull)",
    "filterMetadata": "Metadaten",
    "filterMetadataTooltip": "Revs anzeigen, in denen nur extra/Metadaten geändert wurden (z. B. dismissed_gaps)",
    "hiddenCount": "{{count}} ausgeblendet",
    "noMatch": "keine Revisionen passen zu den aktuellen Filtern",
    "none": "(keine)",
    "opDelete": "LÖSCHEN",
    "opFs": "FS",
    "opPatch": "PATCH",
    "opPromote": "PROMOTE",
    "opWrite": "WRITE",
    "restore": "Wiederherstellen",
    "restoreConfirm": "Wiederherstellen",
    "restoreMessage": "Der aktuelle Inhalt von {{cardId}} wird mit dem Inhalt dieser Revision überschrieben. Die Wiederherstellung selbst wird als neue Rev festgehalten — nichts geht verloren, aber die Änderung ist im Verlauf sichtbar.",
    "restoreTitle": "Rev {{rev}} wiederherstellen?",
    "restoreTooltip": "diese Rev als aktuellen Inhalt wiederherstellen",
    "restoring": "Stelle wieder her…",
    "revCount_one": "{{count}} Rev",
    "revCount_other": "{{count}} Revs",
    "revLabel": "Rev {{rev}}",
    "snapshot": "Schnappschuss",
    "startsHere": "Verlauf beginnt hier",
    "title": "VERLAUF",
    "undeleteConfirm": "Wiederherstellen",
    "undeleteMessage": "Die Karte wird aus dem Inhalt dieser Revision neu erstellt. Die Wiederherstellung wird als neue Rev festgehalten, sodass das Löschereignis im Verlauf erhalten bleibt.",
    "undeleteTitle": "{{cardId}} wiederherstellen?",
    "yesterday": "gestern"
  },
  "homepage": {
    "ccBullet1Body": "· plus Thread- und Dokument-Reader. Schreibzugriffe sind auf fact / statement / question beschränkt — decisions bleiben deine.",
    "ccBullet1Label": "MCP · READ",
    "ccBullet1Title": "Fünf Lese-Tools, ein sicherer Schreibzugriff",
    "ccBullet2BodyPart1": "Build-Session-Funde kommen als gap-Karten zurück, getaggt mit",
    "ccBullet2BodyPart2": ". Du triagierst im Verzeichnis; das CLI landet niemals decisions für dich.",
    "ccBullet2Label": "CLI · PROPOSE",
    "ccBullet2Title": "flag · fact · mark-built",
    "ccBullet3BodyPart1": "Sobald eine Karte als",
    "ccBullet3BodyPart2": "markiert ist, lösen Änderungen am Inhalt das Drift-Bit aus. Die UI zeigt, wo die Spec sich bewegt hat, ohne dass der Code folgt.",
    "ccBullet3Label": "DRIFT DETECTION",
    "ccBullet3Title": "Spec ↔ Code automatisch markieren",
    "ccHeadingLine1": "Karten als ambienter Kontext.",
    "ccHeadingLine2": "Funde als gap-Vorschläge.",
    "ccIntroPart1": "Draftlize kommt als",
    "ccIntroPart2": "(eigenständige",
    "ccIntroPart3": "Binary) und als",
    "ccIntroPart4": ", die Karten in dein Repo spiegelt. Claude Code, Cursor und vim lesen sie als ambienten Kontext; Funde kommen als gap-Vorschläge zurück, die du triagierst.",
    "ccIntroStrong1": "MCP-Server",
    "ccIntroStrong2": "CLI",
    "ccLabel": "ABB. 5 · EXTERNE AGENTS",
    "compareColChatGPT": "ChatGPT / Claude",
    "compareColDraftlize": "Draftlize",
    "compareColLinear": "Linear Docs",
    "compareColNotion": "Notion AI",
    "compareHeading": "Gebaut für Produktdenken,",
    "compareHeadingEm": "nicht generische Notizen.",
    "compareIntro": "Generische Notiz-Apps wurden für statische Dokumente gebaut. ChatGPT wurde für zustandslose Chats gebaut. Draftlize ist das erste Substrat, in dem deine Produktentscheidungen über Konversationen, Agenten und Sprints hinweg zinseszinslich wachsen.",
    "compareLabel": "Warum Draftlize",
    "compareLegendNo": "—",
    "compareLegendPartial": "teilweise",
    "compareLegendYes": "nativ",
    "compareRow1": "Persistenter Context über Chats hinweg",
    "compareRow2": "Abhängigkeiten automatisch als stale markieren bei Spec-Änderung",
    "compareRow3": "Entscheidungen sind adressierbar, nicht in Prosa vergraben",
    "compareRow4": "Thread-übergreifende Konflikterkennung",
    "compareRow5": "Erstklassiger Context für Claude Code / Cursor / MCP",
    "compareRow6": "Karten-Level-Historie + Provenance (wer, wann, warum)",
    "compareRow7": "Vollständigen Graph jederzeit als Markdown exportieren",
    "demoAriaLabel": "Stale-Propagations-Demo",
    "demoButtonIdle": "c-04 NEU SCHREIBEN →",
    "demoButtonReset": "ZURÜCKSETZEN ↻",
    "demoButtonWriting": "SCHREIBE…",
    "demoByYou": "VON DIR",
    "demoCardDecision": "Magiesystem: {{value}}",
    "demoCardDecisionPrefix": "Magiesystem:",
    "demoCardQuestion": "Wie zeigt die UI den Elementwechsel, sobald ein zweiter Slot freigeschaltet ist?",
    "demoCardStatement1": "Boss „Pyrhad” Schwäche — Wasser-Burst-Schaden bestimmt das Kampftempo",
    "demoCardStatement2": "Versteckte Route in Stufe 3 braucht mindestens einen Erd-Element-Charakter",
    "demoNarrateIdle": "Ändere eine decision · sieh zu, wie abhängige Karten als stale markiert werden",
    "doc1Bul1": "Free 0,1×-Kontingent treibt die Pro-Conversion",
    "doc1Bul2": "Max könnte den Self-Host-Pfad kannibalisieren",
    "doc1Cards": "14 KARTEN",
    "doc1Hdg1": "## Hintergrund",
    "doc1Hdg2": "## Entscheidung",
    "doc1Hdg3": "## Abwägungen",
    "doc1Hdg4": "## Offen",
    "doc1Row1": "Zielgruppe: Indie-Café-Inhaber, $25 Tooling-Obergrenze",
    "doc1Row2": "Prepaid-Wallet · pay as you go · $5 gratis",
    "doc1Row3": "Heavy-Usage-Persona",
    "doc1Stale": "2 STALE",
    "doc2Cards": "9 KARTEN",
    "doc2Hdg1": "1 · Das Problem",
    "doc2Hdg2": "2 · Die Mechanik",
    "doc2Hdg3": "3 · Die Demo",
    "doc2Hdg4": "4 · Markt",
    "doc2Hdg5": "5 · Geschäftsmodell",
    "doc2Row1": "KI-Chats verflachen nach Zug 30",
    "doc2Row2": "Kartengraph + Stale-Propagation",
    "doc2Row3": "UC-01 Happy Path",
    "doc2Row4": "AI-native Operatoren",
    "doc2Row5": "Prepaid-Wallet",
    "doc3Body1Em": "die Argumentation vertieft sich nicht mehr",
    "doc3Body1Part1": "Beim dreißigsten Zug merken die meisten dasselbe:",
    "doc3Body1Part2": "und wird dünner. Das Modell ist nicht kaputt — es fehlt das Artefakt…",
    "doc3Body2Em": "decision",
    "doc3Body2Part1": "Schreibe eine",
    "doc3Body2Part2": "-Karte neu. Jeder abhängige Gedanke wird stale, durchgestrichen und bernsteinfarben getönt…",
    "doc3Cards": "6 KARTEN",
    "doc3Hdg1": "Warum Draftlize",
    "doc3Hdg2": "Die Mechanik",
    "doc3Stale": "1 STALE",
    "doc4Bul1": "Vision · einzeilige Positionierung",
    "doc4Bul2": "Warum es existiert (zwei Überzeugungen)",
    "doc4Bul3": "└ Output, nicht Notizen",
    "doc4Bul4": "└ Denken IST Kollaboration",
    "doc4Bul5": "Was aus v3 übernommen wird",
    "doc4Bul6": "Edge — PG als SoT",
    "doc4Bul7": "Erfolgskriterien (5)",
    "doc4Cards": "22 KARTEN",
    "docClean": "SAUBER",
    "docTemplate1Label": "VORLAGE 01",
    "docTemplate2Label": "VORLAGE 02",
    "docTemplate3Label": "VORLAGE 03",
    "docTemplate4Label": "VORLAGE 04",
    "docsHeadingLine1": "Generiere den Entwurf.",
    "docsHeadingLine2": "Behalte die Karten als Wahrheit.",
    "docsIntroEm": "abgeleitete Ansichten",
    "docsIntroPart1": "Dokumente sind",
    "docsIntroPart2": ". Jede Zeile speichert Template + Markdown +",
    "docsIntroPart3": ". Wenn sich eine referenzierte Karte ändert, schickt ein Hintergrund-Detector",
    "docsIntroPart4": "via SSE — der bernsteinfarbene Punkt erscheint in dem Moment, in dem die Quelle driftet.",
    "docsLabel": "ABB. 4 · LANGFORM-OUTPUT",
    "edition": "BD. 1 · AUSGABE 2026",
    "faq1AnswerPart1": "Nein. Es gibt kein Abo — also nichts zu kündigen. Du zahlst nur, was du nutzt, von deinem Guthaben. Dein Guthaben verfällt nie, und du behältst den Account, solange du willst.",
    "faq1AnswerPart2": "Exportiere jederzeit alles als Plain Markdown — kein Lock-in.",
    "faq1Question": "Brauche ich ein Abo?",
    "faq2Answer": "Jederzeit. Vollständiger Markdown-Export jeder Karte, Threads, Dokumente, Historie und Ref-Dateien. Plain Files — kein Lock-in, kein proprietäres Format. Nimm es mit zu Obsidian, Notion, vim, wohin du willst.",
    "faq2Question": "Kann ich meine Daten exportieren?",
    "faq3Answer": "Deine Karten bleiben deine. Wir trainieren niemals Modelle auf deinen Daten. Server läuft als stateless Container auf Fly.io; Daten leben in deinem tenant-isolierten Postgres + Tigris S3. Vollständige Datenlöschungsanfragen werden innerhalb 7 Tagen ausgeführt.",
    "faq3Question": "Was ist mit Privatsphäre / Datenbesitz?",
    "faq4Answer": "Existierende Markdown / PDF / Docs in das _refs/ Panel ziehen, und der Agent extrahiert Karten daraus. Es gibt noch keinen One-Click-Import — aber der Agent liest, was du gibst, und schlägt Karten zur einzelnen Annahme/Ablehnung vor. Die meisten PMs melden 30-60 Min, um aus existierenden Docs ein nutzbares Projekt zu seedn.",
    "faq4Question": "Wie migriere ich von Notion / Linear / einem Ordner voller Docs?",
    "faq5Answer": "Es gibt keine Cap und kein Stufen-System. Jeder Agenten-Lauf wird einfach von deinem Guthaben abgezogen — du siehst die Kosten pro Aktion. Wird das Guthaben knapp, lädst du jederzeit ab $5 auf; läuft es leer, pausiert die Nutzung, bis du auflädst. Dein Guthaben verfällt nie.",
    "faq5Question": "Was passiert, wenn mein Guthaben zur Neige geht?",
    "faqHeading": "Häufige Fragen",
    "finalBody": "Bring dein Produktdenken in ein Substrat, das AI-Agenten lesen UND schreiben können. Bei Anmeldung gibt's $5 Guthaben — danach zahlst du nur, was du nutzt. Kein Abo, kein Lock-in.",
    "finalCta": "ENTER WITH INVITE CODE",
    "finalHeadingLine1": "Hör auf, die Artefakte zu verlieren.",
    "finalHeadingLine2": "Fang an, sie zu behalten.",
    "footerAriaGitHub": "Mit GitHub anmelden",
    "footerAriaGoogle": "Mit Google anmelden",
    "footerAriaMagicLink": "Per E-Mail-Magic-Link anmelden",
    "footerBlurb": "Ein Agent-nativer Ideen-Inkubator. Gebaut auf einem selbst-gehosteten Rust-Agent, Postgres + pgvector, S3-gestützten Refs. Closed-Source-SaaS — deine Daten exportierst du jederzeit als Markdown.",
    "footerContact": "KONTAKT",
    "footerEdition": "BD. 1 · NR. 1 · GLOBAL EARLY ACCESS · AUSGABE 2026",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerLanguage": "SPRACHE",
    "footerLanguageNote": "Pro-Thread überschreibbar",
    "footerMagicLink": "MAGIC LINK",
    "footerPrivacy": "DATENSCHUTZ",
    "footerSignIn": "ANMELDEN",
    "footerTerms": "AGB",
    "founderBody": "Bei jedem neuen Claude-Chat erklärte ich erneut, warum wir das Freemium-Modell verworfen haben, was die Onboarding-Entscheidung war, warum wir Stripe statt Lemon wählten. Im dritten Sprint merkte ich — ich machte keine Produktarbeit, ich betrieb Context-Recovery. Also baute ich ein Substrat, in dem AI Entscheidungen lesen UND schreiben kann, nicht nur im Chat-Verlauf sehen. Draftlize benutze ich täglich. Wenn du ein PM bist, der in AI-Chats lebt und die halbe Woche mit Wiederholungen verliert, bist du genau die Person, für die ich baue.",
    "founderHeading": "Von einem PM, der genug hatte vom",
    "founderHeadingEm": "wiederholten Context-Erklären.",
    "founderLabel": "Warum ich das gebaut habe",
    "founderSig": "— Draftlize Gründer",
    "gainLabel": "NUTZEN",
    "heroCtaReadMechanic": "DIE MECHANIK LESEN",
    "heroCtaStartFree": "ENTER WITH INVITE CODE",
    "heroLabel": "Limited beta — invite only",
    "heroLedePart1": "Für PMs und Produktdesigner:innen. Jedes Spec, jede Entscheidung, jede Begründung wird zu einer",
    "heroLedePart2": ". Ändere ein Spec — jeder abhängige Thread wird",
    "heroLedePart3": ". Entscheidungen werden nicht mehr jeden Sprint neu verhandelt.",
    "heroLedeStrong1": "adressierbaren Karte",
    "heroLedeStrong2": "automatisch als stale markiert",
    "heroRoiLine": "PMs verlieren 5+ Stunden/Woche durch Context-Wiederholung an AI. Draftlize behält ihn.",
    "heroStack1": "SELBST-GEHOSTETER RUST AGENT",
    "heroStack2": "POSTGRES + PGVECTOR",
    "heroStack3": "MCP + CLI · CLAUDE CODE-READY",
    "heroTitleLine1": "Denke mit einem Agent.",
    "heroTitleLine2": "Behalte das Artefakt.",
    "mechanic1BodyPart1": "Jede Karte ist ein strukturiertes Atom —",
    "mechanic1BodyPart2": " Wikilinks ziehen die Kanten. Keine „Hauptdoc + Anhänge”-Dualität.",
    "mechanic1Title": "Der Kartengraph IST das Dokument.",
    "mechanic2BodyPart1": "Schreibe eine",
    "mechanic2BodyPart2": "neu → das Substrat läuft",
    "mechanic2BodyPart3": "rückwärts → jeder transitiv Abhängige wird",
    "mechanic2BodyPart4": "Die UI streicht durch und markiert in Bernstein.",
    "mechanic2Title": "Stale-Propagation als First-Class-Verhalten.",
    "mechanic3BodyPart1": "Wenn der Agent unsicher ist,",
    "mechanic3BodyPart2": "legt er einen",
    "mechanic3BodyPart3": "ab. Immer sichtbar, nie einklappbar. Übernehmen · Diskutieren · Verwerfen.",
    "mechanic3Title": "Das Gap-Verzeichnis lebt in Spalte vier.",
    "mechanic4BodyPart1": "Öffne viele Threads zu einem Projekt — sie teilen Karten, aber nicht den Chatverlauf. Ein Hintergrund-Detector ordnet Widersprüche threadübergreifend ein als",
    "mechanic4Title": "Multi-Thread mit automatischer Konflikterkennung.",
    "mechanicHeadingLine1": "Vier Züge,",
    "mechanicHeadingLine2": "die das hier nicht zu einer Notizen-App machen.",
    "mechanicLabel": "ABB. 1 · KERNMECHANIK",
    "mockCardDecision": "Prepaid-Wallet · pay as you go · Guthaben verfällt nie",
    "mockCardGap": "market-research/c-31 sagt $35–50 Budget — widerspricht c-09",
    "mockCardStatement1": "Indie-Café-Inhaber deckeln das monatliche Tooling bei ~$25 — pay as you go passt zu jedem Budget",
    "mockCardStatement2": "$5 Startguthaben lässt Nutzer testen, bevor sie aufladen",
    "mockCards": "KARTEN",
    "mockGapConflict": "Budgetzahl widerspricht sich threadübergreifend",
    "mockGapInterp1": "„indie cafe” — kleine Ketten einbeziehen?",
    "mockGapInterp2": "Heavy-Usage-Persona undefiniert",
    "mockGapLedger": "GAP-VERZEICHNIS",
    "mockThreads": "THREADS",
    "navDocuments": "DOKUMENTE",
    "navEarlyAccess": "EARLY ACCESS →",
    "navMechanic": "MECHANIK",
    "navPeople": "MENSCHEN",
    "navPricing": "PREISE",
    "navProblem": "PROBLEM",
    "painLabel": "SCHMERZ",
    "persona1Gain": "Karten sind das persistente Gedächtnis. Neuer Thread, der Agent liest c-04 (Preisentscheidung) und c-09 (Zielgruppe) als ambient context. Wiederholungen sinken auf null. Specs driften nicht mehr, weil abhängige Threads sich beim Editieren automatisch markieren.",
    "persona1Name": "Die Product Managerin",
    "persona1Pain": "Jeder neue Claude-Chat verhandelt erneut Preise, Zielgruppe, Onboarding-Entscheidungen aus Woche 2. Am Freitag hat sie 8 Stunden mit Context-Wiederholung verbracht, den sie schon längst geklärt hatte.",
    "persona1Role": "Mira — Senior PM bei einem Series-A-SaaS, fährt Roadmap mit Claude als Sparring-Partnerin",
    "persona1Snippet": "\"Meine AI-gestützte PM-Zeit von 12 auf 6 Stunden/Woche gekürzt. Gleicher Output, halbe Wiederholung.\"",
    "persona1SnippetLabel": "AUS DOGFOOD · WOCHE 4",
    "persona1Tag": "№ 01 · PM",
    "persona2GainPart1": "Jede Designentscheidung ist eine Karte. Der Agent liest c-03 (Farbprinzip) und c-22 (Komponenten-Lockup-Begründung), bevor er Änderungen vorschlägt. Surface-übergreifende Widersprüche tauchen als",
    "persona2GainPart2": "auf, bevor der PR geöffnet wird.",
    "persona2Name": "Der Produktdesigner",
    "persona2Pain": "Designprinzipien, System-Tokens und Komponenten-Begründungen leben in 3 Figma-Dateien, 2 Notion-Pages und 47 Loom-Threads. AI-Design-Konversationen vergessen bis zum nächsten Sprint, warum er Sentence Case statt Title Case gewählt hat.",
    "persona2Role": "Diego — Staff Product Designer bei einem Fintech, Design System + 4 Produkt-Surfaces",
    "persona2Snippet": "\"Sentence-Case-Verletzung in 3 Surfaces in 5 Sekunden gefangen. Früher: 30-Min-Audit vor jedem Design Review.\"",
    "persona2SnippetLabel": "AUS DOGFOOD · WOCHE 6",
    "persona2Tag": "№ 02 · PRODUKTDESIGNER",
    "personasHeadingLine1": "Zwei Rollen.",
    "personasHeadingLine2Em": "Context-Verdunstung",
    "personasHeadingLine2Part1": "Zwei Momente, in denen",
    "personasHeadingLine2Part2": "teuer wird.",
    "personasIntro": "Draftlize verdient seinen Platz dort, wo eine Produktverschiebung das Umschreiben jeder abhängigen Entscheidung kaskadiert. PMs und Produktdesigner spüren das am stärksten — ihr Denken IST das Liefergut.",
    "personasLabel": "ABB. 2 · WER GREIFT ZU DRAFTLIZE",
    "pricingTrust1": "$5 Startguthaben gratis",
    "pricingTrust2": "Daten jederzeit exportierbar",
    "pricingTrust3": "Kein Lock-in · jederzeit exportierbar",
    "problem1Body": "In Woche 3 hast du den Preis festgelegt. Woche 7, im neuen Chat, diskutiert ihr denselben Trade-off von Grund auf — weil im Chat-Verlauf nichts adressierbar ist.",
    "problem1Num": "I",
    "problem1Title": "Entscheidungen werden jeden Sprint neu verhandelt",
    "problem2Body": "Du änderst eine Annahme — Onboarding-Flow, Zielgruppe, Preistier — und jedes davon abhängige Dokument verrottet still. Am Demo-Tag erfährst du, welches.",
    "problem2Num": "II",
    "problem2Title": "Specs driften, ohne dass jemand es merkt",
    "problem3Body": "Neuer Chat, neue Amnesie. Du erklärst zum fünften Mal, warum ihr das Freemium-Modell abgelehnt habt. Context, der sich aufaddieren sollte, tut es nicht.",
    "problem3Num": "III",
    "problem3Title": "Dein Agent vergisst dich bei jedem Gespräch",
    "problemHeading": "Die drei Schmerzen, die AI-gestützte Produktarbeit",
    "problemHeadingEm": "still verursacht.",
    "pullQuote": "Du kannst eine Stunde lang mit einem Agent denken und am Ende nichts vorzuweisen haben — es sei denn, das Artefakt erinnert sich.",
    "pullQuoteCite": "Aus dem Draftlize-Dogfood-Log · 2026-02",
    "surfaceClaudeCitedBody": "Prepaid-Wallet · pay as you go · Guthaben verfällt nie",
    "surfaceClaudeReplyPrefix": "Aus",
    "surfaceClaudeTitle": "C · CLAUDE CODE",
    "surfaceClaudeUserMsg": "was steht eigentlich auf der Preis-Karte?",
    "surfaceClaudeWhoYou": "DU",
    "surfaceWebCaption": "→ gerendert mit Art-Glyph, Hover für Stale-Graph-Preview, ziehen zum Umsortieren, klicken für die volle Verlaufs-Schublade",
    "surfaceWebCardBody": "Prepaid-Wallet · pay as you go · Guthaben verfällt nie",
    "surfaceWebCardMeta": "3 ABHÄNGIGE · ZULETZT VOR 14m BEARBEITET · VON DIR",
    "surfaceWebTitle": "A · WEB-UI · CardPeek",
    "surfacesHeadingEm": "erstklassigem Context machen.",
    "surfacesHeadingPart1": "Zwei Surfaces, die deine Karten zu",
    "surfacesIntroPart1": "Die Draftlize Web-App + Claude Code Integration. Dieselbe Karte,",
    "surfacesIntroPart2": "aus beiden Richtungen adressierbar. Entwickler bekommen das volle Set (CLI, MCP, raw Markdown) auf der Entwickler-Seite unten.",
    "surfacesLabel": "ABB. 3 · WO DEINE KARTEN LEBEN",
    "testimonial1Quote": "Ich habe an einem Dienstag das Magiesystem geändert. Bis Mittwoch hatte ich 20 abhängige Karten abgearbeitet. Ohne Stale-Propagation wäre das ein Monat Bug-Reports gewesen.",
    "testimonial1Role": "Solo-Dev · Roguelike",
    "testimonial2Quote": "Die threadübergreifende Konflikterkennung hat eine Guidance-Diskrepanz zwischen zwei Biotech-Reports gefangen, bevor ich das Memo abgeschickt habe. Das ist die Art Catch, die man erst zu schätzen weiß, wenn sie einem einmal den Ruf gerettet hat.",
    "testimonial2Role": "Investigative Journalistin",
    "testimonial3Quote": "Karten als ambienter Kontext für Claude Code ist der Killer-Move. Der Agent fragt nicht mehr „was hast du letzte Woche entschieden”, weil letzte Woche direkt im Repo liegt.",
    "testimonial3Role": "Indie-Hacker · B2B-Tools",
    "voicesHeadingEm": "Und die Fragen, die dabei aufkommen.",
    "voicesHeadingPart1": "Was Dogfood-Nutzer sagen."
  },
  "import": {
    "changeFile": "klicken oder anderes ablegen zum Wechseln",
    "dropZone": "Lege ein Draftlize-Export-.zip hier ab",
    "dropZoneHint": "oder klicke, um eine Datei zu wählen",
    "errNotZip": "Eine .zip-Datei erwartet, erhalten: {{name}}",
    "heading": "Projekt importieren",
    "importButton": "Importieren →",
    "importing": "Importiere…",
    "projectNameLabel": "PROJEKTNAME (OPTIONAL)",
    "projectNamePlaceholder": "leer lassen für \"<original> (imported)\""
  },
  "login": {
    "codeHint": "Or type the 6-digit code from the email:",
    "codeInvalid": "Invalid or expired code — check the email or request a new one.",
    "codeSubmit": "Sign in",
    "emailPlaceholder": "du@beispiel.de",
    "errorSendFailed": "Konnte nicht senden. Versuche es erneut oder nimm GitHub / Google.",
    "inviteInvalid": "This invite code is invalid or already used",
    "invitePlaceholder": "Invite code",
    "inviteRequired": "An invite code is required to sign up",
    "noInviteWaitlist": "No invite code? Join the waitlist",
    "sendMagicLink": "Magic Link senden",
    "sending": "Sende…",
    "sentBodyPrefix": "Wir haben einen Anmeldelink geschickt an",
    "sentBodySuffix": ". Er läuft in 15 Minuten ab und kann nur einmal verwendet werden.",
    "sentTitle": "Schau in dein Postfach",
    "separatorOr": "oder",
    "signInWithGitHub": "Mit GitHub anmelden",
    "signInWithGoogle": "Mit Google anmelden",
    "tagline": "Agent zum Denken",
    "useDifferentEmail": "Andere E-Mail verwenden",
    "waitlistBack": "Back to sign in",
    "waitlistIntro": "Draftlize is in limited beta. Leave your email and we’ll send you an invite as we open up.",
    "waitlistJoin": "Join waitlist",
    "waitlistJoinedBody": "We’ll email you an invite code as spots open up.",
    "waitlistJoinedTitle": "You’re on the list",
    "wechatHint": "Sign in with your email — we’ll send you a login link."
  },
  "refs": {
    "attach": "anhängen",
    "attachTitle": "an die aktuelle Nachricht anhängen",
    "confirmDelete": "Ref „{{name}}” löschen?",
    "dismissError": "klicken zum Schließen",
    "emptyState": "noch keine Refs — lege eine Datei ab oder nutze den Upload unten",
    "errDelete": "Löschen: {{message}}",
    "errLoad": "Refs laden: {{message}}",
    "errRead": "Lesen: {{message}}",
    "heading": "PROJEKT-REFS",
    "peekTitle": "Inhalt vorschauen",
    "sharedAcrossThreads": "threadübergreifend geteilt",
    "uploadNew": "+ neu hochladen",
    "uploading": "lade {{count}} hoch…"
  },
  "settings": {
    "adminBadge": "Admin",
    "adminTools": "ADMIN-TOOLS",
    "adminToolsHint": "Übersicht, LLM-Nutzung, Fehler-Triage, Nutzer.",
    "buildBinaryHint": "Baue zuerst die Binary: <code>cargo build --release -p draftlize-mcp</code>",
    "copied": "✓ kopiert",
    "copy": "kopieren",
    "copyCommand": "Befehl kopieren",
    "copyToken": "Token kopieren",
    "createToken": "Token erstellen",
    "creating": "erstelle…",
    "deleteConfirm": "„{{name}}” dauerhaft löschen? Karten, Threads und Verlauf gehen alle weg. Das kann nicht rückgängig gemacht werden.",
    "deleteProject": "Projekt löschen…",
    "deleting": "lösche…",
    "errClipboard": "Schreiben in Zwischenablage fehlgeschlagen — Text bitte markieren und manuell kopieren",
    "errCreateToken": "Token erstellen: {{error}}",
    "errDelete": "Löschen: {{error}}",
    "errMcpToggle": "MCP-Toggle: {{error}}",
    "errRevokeToken": "Token widerrufen: {{error}}",
    "errUpdatePack": "Pack aktualisieren: {{error}}",
    "heading": "Einstellungen",
    "integrationsBlurb": "Lasse externe KI-Tools (Claude Code, Cursor, Claude Desktop) die Karten dieses Projekts über <mcp>MCP</mcp> lesen. Nur lesend — sie können Karten über diesen Kanal nicht bearbeiten.",
    "wizardTitle": "Claude Code verbinden",
    "wizardBlurb": "Synchronisiere die Karten dieses Projekts in dein Repo, damit Claude Code (oder jeder Coding-Agent) dasselbe Entscheidungsgedächtnis teilt — und Erkenntnisse zurückschreibt.",
    "wizardStep1": "API-Token erzeugen",
    "wizardGenerate": "Token erzeugen",
    "wizardHaveTokens_one": "Du hast bereits 1 aktives Token — verwende es wieder, falls du das Secret gespeichert hast, oder erzeuge ein neues für diese Maschine.",
    "wizardHaveTokens_other": "Du hast bereits {{count}} aktive Tokens — verwende eines wieder, falls du ein Secret gespeichert hast, oder erzeuge ein neues für diese Maschine.",
    "wizardStep2": "CLI installieren und dieses Projekt verknüpfen",
    "wizardTokenPlaceholder": "<dein dft_…-Token>",
    "wizardCopyAll": "Alle 4 Befehle kopieren",
    "wizardStep2Hint": "Lokaler Dev-Server? Erst DRAFTLIZE_API_URL exportieren.",
    "wizardStep3": "Verbindungsstatus",
    "wizardNoToken": "Warte auf ein Token — erledige zuerst Schritt 1.",
    "wizardWaiting": "Warte auf den ersten CLI-Aufruf … diese Seite prüft alle 10 s neu.",
    "wizardConnected": "Verbunden — Token „{{name}}“ aktiv {{time}}.",
    "wizardIdle": "Letzte CLI-Aktivität {{time}} — führe draftlize pull aus, um neu zu verbinden.",
    "wizardTryNext": "Verbunden! Probiere als Nächstes <code>/draftlize:status</code> in Claude Code.",
    "wizardDevMcp": "LOKALES DEV · MCP-SERVER (DIREKTES POSTGRES)",
    "wizardDevMcpBlurb": "Der MCP-stdio-Server spricht direkt mit Postgres — er funktioniert nur dort, wo die Datenbank erreichbar ist (lokales Dev). Auf anderen Maschinen nutze den CLI-Pfad oben.",
    "inviteCopied": "Copied",
    "inviteCopy": "Copy",
    "inviteRevoked": "Revoked",
    "inviteUsed": "Used",
    "invitesEmpty": "No codes yet. Use Draftlize for a week and grow your project past 20 cards, and 3 invite codes will appear here.",
    "invitesGrantedNow": "You just earned 3 invite codes — thanks for building with us. Share them with people who think out loud.",
    "invitesIntro": "Draftlize is in limited beta — invites let friends skip the waitlist. You earn 3 codes after a week of use and 20 cards.",
    "invitesLoadFailed": "Could not load invites — try again later.",
    "languageHint": "Setzt die Oberfläche und die Antwortsprache des Agents. Karteninhalte werden nie übersetzt.",
    "languageLabel": "Sprache",
    "loading": "Loading…",
    "localeAuto": "Automatisch (Browser folgen)",
    "navAccount": "Konto",
    "navBilling": "Abrechnung",
    "navGeneral": "Allgemein",
    "navIntegrations": "Integrationen",
    "navInvites": "Invites",
    "navTokens": "API-Tokens",
    "noExternalReads": "noch keine externen Lesezugriffe",
    "noProjectGeneral": "Öffne ein Projekt, um auf die allgemeinen Einstellungen zuzugreifen.",
    "noProjectIntegrations": "Öffne ein Projekt, um seine MCP-Integration zu verwalten.",
    "noTokens": "noch keine Tokens",
    "oneTimeInstall": "EINMALIGE INSTALLATION (in deinem Terminal)",
    "openAdminPanel": "Admin-Panel öffnen",
    "packBlank": "leer",
    "pasteIntoShell": "In deine Shell einfügen:",
    "reallyDelete": "wirklich löschen",
    "reallyRevoke": "wirklich widerrufen",
    "recentAccess": "LETZTE ZUGRIFFE",
    "relDays_one": "vor {{count}} T",
    "relDays_other": "vor {{count}} T",
    "relHours_one": "vor {{count}} Std",
    "relHours_other": "vor {{count}} Std",
    "relMinutes_one": "vor {{count}} Min",
    "relMinutes_other": "vor {{count}} Min",
    "relSeconds_one": "vor {{count}} Sek",
    "relSeconds_other": "vor {{count}} Sek",
    "relYesterday": "gestern",
    "renameHint": "in der Seitenleiste umbenennen (Doppelklick)",
    "revoke": "Widerrufen",
    "revoking": "widerrufe…",
    "rowEmail": "E-Mail",
    "rowGithub": "GitHub",
    "rowName": "Name",
    "rowPack": "Pack",
    "rowProjectId": "Projekt-ID",
    "rowStatus": "Status",
    "rowTenant": "Tenant",
    "savedDismiss": "Ich habe es gespeichert — schließen",
    "saving": "speichere…",
    "sectionIntegrations": "INTEGRATIONEN",
    "sectionProject": "PROJEKT",
    "sectionTokens": "API-TOKENS",
    "session": "SITZUNG",
    "signOut": "Abmelden",
    "signedInAs": "ANGEMELDET ALS",
    "signingOut": "melde ab…",
    "statusConnected_one": "verbunden · {{count}} Lesezugriff in 24h",
    "statusConnected_other": "verbunden · {{count}} Lesezugriffe in 24h",
    "statusDisabled": "für dieses Projekt deaktiviert",
    "statusSetUp": "eingerichtet · noch keine Lesezugriffe",
    "statusUnavailable": "nicht verfügbar",
    "toggleDisable": "MCP für dieses Projekt deaktivieren",
    "toggleDisableTitle": "Dieses Projekt vor MCP-Clients verbergen (bestehende Reads werden weiter erfasst; neue Reads werden abgewiesen)",
    "toggleEnable": "MCP für dieses Projekt aktivieren",
    "toggleEnableTitle": "Dieses Projekt wieder für MCP-Clients freigeben",
    "tokenCreated": "erstellt",
    "tokenCreatedNotice": "<name>{{name}}</name> — kopiere das jetzt. Das volle Token wird nur einmal angezeigt und kann später nicht mehr abgerufen werden.",
    "tokenLastUsed": "zuletzt genutzt {{time}}",
    "tokenNamePlaceholder": "Token-Name (z. B. laptop, ci-bot)",
    "tokenNeverUsed": "nie genutzt",
    "tokensBlurb": "Langlebige Bearer-Tokens für das <code>draftlize</code>-CLI und externe MCP-Clients. Jedes Token authentifiziert ALS dein Nutzer — behandle sie wie Passwörter.",
    "unknownClient": "unbekannt",
    "unverified": "unverifiziert"
  },
  "sidebar": {
    "admin": "ADMIN",
    "adminTitle": "Admin · Übersicht / Nutzung / Fehler / Nutzer",
    "archiveThread": "Thread archivieren",
    "collapse": "Seitenleiste einklappen",
    "create": "ANLEGEN",
    "doubleClickRename": "Doppelklick zum Umbenennen",
    "expand": "Seitenleiste ausklappen",
    "importFromZip": "Aus .zip importieren",
    "mcpChipTitle": "MCP-Integration · Einstellungen → Integrationen öffnen",
    "mcpChip_one": "⚡ MCP · {{count}} Lesezugriff",
    "mcpChip_other": "⚡ MCP · {{count}} Lesezugriffe",
    "newEmptyProject": "+ Neues leeres Projekt",
    "newMenu": "+ NEU",
    "newThread": "+ NEU",
    "noThreads": "noch keine Threads — fang einen an",
    "openAccount": "Konto öffnen",
    "openAccountAria": "Kontoeinstellungen öffnen",
    "openAccountTitle": "{{identity}} — Konto öffnen",
    "projectNamePlaceholder": "Projektname…",
    "projects": "PROJEKTE",
    "settings": "EINSTELLUNGEN",
    "tagline": "Agent zum Denken",
    "threads": "THREADS",
    "untitled": "ohne Titel"
  },
  "tips": {
    "cardShortcuts": "Karte öffnen, dann n neu · e bearbeiten · esc schließen",
    "dragFile": "Ziehe eine Datei auf das Eingabefeld, um sie als Projekt-Ref anzuhängen",
    "editHistory": "Karten behalten den vollen Bearbeitungsverlauf — Karte öffnen und auf die Verlaufs-Schublade tippen",
    "exportProject": "Klicke „N Karten” in der Fußzeile des Karten-Panels, um das ganze Projekt herunterzuladen",
    "hideTips": "Tipps ausblenden",
    "importZip": "+ NEW ▾ in der Seitenleiste kann auch ein Draftlize-.zip-Export importieren",
    "newline": "⇧↵ für neue Zeile · ↵ zum Senden",
    "nextTip": "nächster Tipp",
    "projectRefs": "📎 listet Projekt-Refs — anhängen, vorschauen, hochladen oder löschen",
    "renameDoubleClick": "Doppelklick auf einen Projekt- oder Thread-Namen, um ihn umzubenennen",
    "settings": "⚙ Einstellungen (unten in der Seitenleiste) lässt dich das Pack tauschen oder das Projekt löschen"
  },
  "usage": {
    "autoCompactionAt": "Auto-Compaction bei {{tokens}} ({{pct}}%)",
    "breakdownNextTurn": "AUFSCHLÜSSELUNG (NÄCHSTER ZUG)",
    "cacheRead": "Cache Read",
    "cacheWrite": "Cache Write",
    "chipTitle": "Kontext: {{input}} / {{window}} ({{pct}}%) — klicken für Details",
    "compactedThisTurn_one": "📦 {{count}} Nachricht diese Runde kompaktiert",
    "compactedThisTurn_other": "📦 {{count}} Nachrichten diese Runde kompaktiert",
    "compactionActive": "Auto-Compaction aktiv",
    "compactionActiveBody_one": "{{count}} ältere Nachricht wird durch eine strukturierte Zusammenfassung ersetzt, damit das LLM unter dem Input-Budget bleibt. Der volle Verlauf ist weiterhin im Thread — nur die Sicht des LLMs ist beschnitten.",
    "compactionActiveBody_other": "{{count}} ältere Nachrichten werden durch eine strukturierte Zusammenfassung ersetzt, damit das LLM unter dem Input-Budget bleibt. Der volle Verlauf ist weiterhin im Thread — nur die Sicht des LLMs ist beschnitten.",
    "compactionActiveLabel": "📦 Compaction aktiv:",
    "compactionHint": "Auto-Compaction wird an der orangefarbenen Linie ({{tokens}}) ausgelöst. Ältere Nachrichten werden durch eine strukturierte Zusammenfassung ersetzt; der volle Verlauf bleibt im Thread.",
    "contextWindow": "KONTEXTFENSTER",
    "freeSpace": "Freier Platz",
    "input": "Input",
    "messages": "Nachrichten",
    "messagesCompacted_one": "Nachrichten ({{count}} kompaktiert)",
    "messagesCompacted_other": "Nachrichten ({{count}} kompaktiert)",
    "mobileChipAria": "Kontextfenster {{pct}}% — tippen für Details",
    "mobileSheetAria": "Kontextfenster-Details",
    "mobileSheetTitle": "Kontext · {{input}} / {{window}} ({{pct}}%)",
    "output": "Output",
    "sessionTotals": "SITZUNGSGESAMT (PROVIDER)",
    "systemPrompt": "System-Prompt",
    "toolsSchema": "Tools-Schema",
    "withoutCompaction": "Ohne Compaction"
  },
  "marketing": {
    "footerProduct": "Produkt",
    "navForDevelopers": "Für Entwickler",
    "navForPm": "Für PMs",
    "navHome": "Start",
    "navOpenApp": "App öffnen →",
    "navStart": "Kostenlos starten →",
    "navPricing": "Preise"
  },
  "pricing": {
    "heroLabel": "Preise",
    "prepaidHeroTitle": "Prepaid. Du zahlst für das,",
    "prepaidHeroTitleEm": "was du nutzt — sonst nichts.",
    "prepaidLede": "Kein Abo, keine Stufen, keine monatliche Rechnung. Melde dich an und starte mit $5 Guthaben, dann zahlst du nur für die AI-Nutzung, die du tatsächlich verbrauchst. Lade jederzeit auf, ab $5 — und was du nicht ausgibst, bleibt in deinem Wallet und verfällt nie.",
    "prepaidHeroCta": "Mit $5 gratis starten",
    "pointsHeadingPart1": "Drei Dinge, die es",
    "pointsHeadingEm": "ehrlich halten.",
    "pointsSubhead": "Pro Token abgerechnet, zu einem festen, veröffentlichten Tarif. Keine Sitze, keine Stufen, keine Rechnung, mit der du nicht gerechnet hast.",
    "point1Title": "Gratis loslegen",
    "point1Tag": "Guthaben bei Anmeldung",
    "point1Body": "Jedes neue Konto erhält $5, die du ausgeben kannst, wie du willst — zum Start keine Karte nötig. Genug, um ein echtes Projekt anzustoßen und den Loop zu spüren, bevor du einen Cent zahlst.",
    "point2Title": "Pay as you go",
    "point2Tag": "pro Token abgerechnet",
    "point2Body": "Wenn das Gratisguthaben aufgebraucht ist, lädst du ab $5 auf und machst weiter. Berechnet werden nur die Token, die du tatsächlich nutzt, zu einem festen Tarif — nie Sitze oder ein Plan, dem du entwächst.",
    "point3Title": "Verfällt nie",
    "point3Tag": "dein Guthaben gehört dir",
    "point3Body": "Gekauftes Guthaben verschwindet nicht am Monatsende. Lege ein Quartal Pause ein und komm zurück zu genau dem Guthaben, das du hinterlassen hast. Keine Verlängerung, nichts zu kündigen.",
    "qaPrepaid1Q": "Wie funktioniert die Abrechnung genau?",
    "qaPrepaid1A": "Jeder AI-Request hat Token-Kosten in Cents, die beim Arbeiten von deinem Wallet abgezogen werden. Du startest mit $5 gratis; wird es knapp, lädst du ab $5 auf. Kein Abo, keine monatliche Gebühr — du zahlst für die Nutzung und sonst nichts.",
    "qaPrepaid2Q": "Brauche ich zum Start eine Kreditkarte?",
    "qaPrepaid2A": "Nein. Die $5 Startguthaben sind da, sobald du dich anmeldest. Eine Karte hinterlegst du nur, um darüber hinaus aufzuladen — und das ist eine einmalige Zahlung, kein wiederkehrendes Abo.",
    "qaPrepaid3Q": "Was passiert, wenn mein Guthaben aufgebraucht ist?",
    "qaPrepaid3A": "Requests pausieren, statt fehlzuschlagen, sodass du nie überraschend belastet wirst. Lade ab $5 unter Einstellungen → Abrechnung auf, das Guthaben ist sofort da — mach genau dort weiter, wo du aufgehört hast.",
    "qaPrepaid4Q": "Verfällt mein Guthaben?",
    "qaPrepaid4A": "Niemals. Was du auflädst, bleibt unbegrenzt in deinem Wallet. Intensiver Monat, ruhiger Monat — dein Guthaben wird übertragen, ohne Verlängerung und ohne etwas zu kündigen.",
    "qaPrepaid5Q": "Gibt es noch Monatspläne oder Stufen?",
    "qaPrepaid5A": "Nein — die alten Pro- / Power- / Max-Stufen sind abgeschafft. Jeder bekommt das vollständige Draftlize und zahlt denselben Tarif pro Token. Das Einzige, was variiert, ist, wie viel du nutzt.",
    "prepaidFinalBody": "Starte mit $5 gratis, zahle nur für das, was du nutzt, und behalte jeden Cent, den du nicht ausgibst. Das ist das ganze Modell.",
    "pageDescription": "Nutzungsbasierte Abrechnung, kein Abo. Bei Anmeldung gibt's $5 Guthaben — danach zahlst du nur, was du nutzt, für das vollständige Draftlize: Card Graph, stale-Propagation, Thread-übergreifende Konfliktdetektion, Claude Code + MCP Integration. Ab $5 aufladen, Guthaben verfällt nie.",
    "pageTitle": "Preise · Draftlize — pay-as-you-go, kein Abo, $5 Startguthaben",
    "qaHeading": "Preis-spezifische Fragen"
  },
  "forPm": {
    "ctaBody": "$5 Guthaben bei Anmeldung — danach zahlst du nur, was du nutzt. Kein Abo, kein Lock-in. Die meisten PMs sehen ihre Wiederholungszeit in der ersten Woche um 50% sinken.",
    "ctaButton": "Loslegen",
    "ctaTitle": "Ganz Draftlize.",
    "ctaTitleEm": "Zahl nach Verbrauch.",
    "heroLabel": "Für Product Manager",
    "heroLede": "Du hast dein Produktdenken bereits in AI-Chats verlagert. Hör jetzt auf, es zu verlieren. Draftlize behält jede Entscheidung, jede Abhängigkeit, jede Begründung als adressierbare Karte, die der Agent lesen UND schreiben kann — Context wächst sprintübergreifend zinseszinslich statt zu verdunsten.",
    "heroTitle": "Für PMs, die Roadmap",
    "heroTitleEm": "mit AI als Sparring-Partner fahren.",
    "pageDescription": "Eine Werkbank für PMs, die mit AI-Agenten Roadmap fahren. Jedes Spec, jede Entscheidung, jede Begründung wird zu einer adressierbaren Karte. Ändere ein Spec — jeder abhängige Thread markiert sich automatisch als stale. Reduziere AI-gestützte PM-Zeit um ~50%.",
    "pageTitle": "Für Product Manager · Draftlize — Höre auf, AI Context wiederholt zu erklären",
    "scenario1Body": "In Woche 3 hast du dein Preismodell entschieden. Woche 7, im neuen Chat, liest der Agent c-04 (Preisentscheidung) als ambient context — und startet von dort. Kein Wiederholen der Analyse, die du bereits gemacht hast.",
    "scenario1Title": "Preisentscheidungen werden nicht neu verhandelt",
    "scenario2Body": "Du änderst den Onboarding-Flow (c-12). Jede PRD-Section, jedes Design-Doc, jede Claude-Konversation, die von c-12 abhing, markiert sich automatisch als stale. Am Demo-Tag hast du das Drift bereits ausgebügelt.",
    "scenario2Title": "Specs driften nicht mehr still",
    "scenario3Body": "In Thread A sagst du \"Ziel SMB\". In Thread B (eine Woche später) sagst du \"Ziel Mid-Market\". Draftlizes Konfliktdetektor reicht das als gap_kind=conflict Karte ein. Du siehst beide, bevor du eines davon ausgeliefert.",
    "scenario3Title": "Thread-übergreifende Konflikte tauchen als Gaps auf"
  },
  "forDevelopers": {
    "ctaBody": "$5 Guthaben bei Anmeldung — danach zahlst du nur, was du nutzt. Kein Abo, kein Lock-in. Volle CLI + MCP + Slash-Commands inklusive.",
    "ctaButton": "Loslegen",
    "ctaTitle": "Karten als Code-Context.",
    "ctaTitleEm": "Specs, die nicht driften.",
    "heroLabel": "Für Entwickler",
    "heroLede": "Draftlize-Karten sind das Substrat. CLI mirrort sie als Markdown in dein Repo. MCP Server stellt sie Claude Code, Cursor und Claude Desktop als erstklassigen Context bereit. Wenn du c-12 implementierst, markiere als built — wenn das Spec sich bewegt, wechselt der Status automatisch zu drift_detected und du weißt, was zu revidieren ist.",
    "heroTitle": "Deine Entscheidungen, adressierbar",
    "heroTitleEm": "in jedem AI-Tool, das du nutzt.",
    "pageDescription": "Draftlize für spec-getriebene Entwicklung mit AI-Agenten. CLI mirrort Karten in dein Repo. MCP Server macht Karten zu erstklassigen Ressourcen für Claude Code / Cursor / Claude Desktop. Spec-Status wechselt automatisch zu drift_detected, wenn das Spec sich bewegt.",
    "pageTitle": "Für Entwickler · Draftlize — Erstklassiger Context für Claude Code, Cursor, MCP",
    "surface1Body": "Karten landen unter `.draftlize/cards/<id>.md` als plain Markdown mit YAML-Frontmatter. Claude Code liest sie als ambient context. `draftlize flag c-7 \"...\"` schreibt eine Gap-Karte zurück an die GapLedger für User-Review.",
    "surface1Title": "CLI — `draftlize pull` in dein Repo",
    "surface2Body": "Eigenständige `draftlize-mcp` Binary spricht JSON-RPC über stdio. Tools: `read_card` / `list_cards` / `search_cards` / `propose_card` (gelockt auf fact/statement/question). URI: `draftlize://<slug>/<cid>` über `/api/resolve` auflösbar.",
    "surface2Title": "MCP Server — stdio JSON-RPC",
    "surface3Body": "Nach `draftlize link <project>` landen vier Slash-Commands in `.claude/skills/draftlize/`: `/draftlize:cite` / `/draftlize:flag` / `/draftlize:fact` / `/draftlize:status`. Claude Code löst sie inline auf.",
    "surface3Title": "Slash-Commands — `/draftlize:cite c-7`",
    "surface4Body": "`draftlize mark-built c-12` setzt den Karten-Status auf `built`. Bearbeite die Karte später, und der Status springt automatisch auf `drift_detected` — der Agent weiß, was aus welcher Snapshot implementiert wurde und was sich seither bewegt hat.",
    "surface4Title": "implementation_status — Spec-Drift-Tracking"
  },
  "share": {
    "footerCta": "Try Draftlize",
    "footerTagline": "Incubate your ideas with an agent",
    "goneBody": "The share may have been revoked by its owner.",
    "goneTitle": "This link is no longer available",
    "graphStats": "{{cards}} cards · {{edges}} connections"
  },
  "feedback": {
    "body": "Scan to join the WeChat group — direct line to the builder, ship notes, and invite codes.",
    "fab": "Early users",
    "qrAlt": "WeChat group QR code",
    "qrFallback": "Group QR coming soon — ping the friend who invited you.",
    "title": "Join the early-user group"
  },
  "onboarding": {
    "beat1Body": "No commands, no syntax. Just describe what you're working on.",
    "beat1Title": "Talk like you would to a sharp colleague.",
    "beat2Body": "When a decision, fact, or question lands, the agent writes it to the cards panel on the right — yours to edit, link, and keep.",
    "beat2Title": "Key thoughts become addressable cards.",
    "beat3Body": "Edit a card others depend on and Draftlize marks everything downstream — so your thinking stays consistent across weeks.",
    "beat3Title": "Change a decision, dependents flag stale.",
    "kicker": "WELCOME TO DRAFTLIZE",
    "skip": "I'll start on my own",
    "starter1Label": "Incubate a product idea",
    "starter1Prompt": "I'm thinking about building a product. Help me think through the core idea, who it's for, and what the riskiest assumption is.",
    "starter2Label": "Plan a feature",
    "starter2Prompt": "Help me spec a new feature. Ask me clarifying questions first, then we can capture the key decisions as we go.",
    "starter3Label": "Think through a decision",
    "starter3Prompt": "I have a decision to make and I want to reason it out loud with you. Let's lay out the options and the trade-offs.",
    "titleLine1": "Think with an agent.",
    "titleLine2": "Keep the artifact.",
    "tryOne": "TRY ONE TO START"
  }
}
